"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUIUserType = exports.NO_FINAL_JEOPARDY_SUBMISSION = exports.NO_FINAL_JEOPARDY_WAGER = exports.NO_DAILY_DOUBLE_WAGER = exports.NO_BUZZ_IN_TIME = exports.NO_QUESTION = exports.Status = exports.Round = void 0;
var Round;
(function (Round) {
    Round[Round["SINGLE"] = 0] = "SINGLE";
    Round[Round["DOUBLE"] = 1] = "DOUBLE";
    Round[Round["FINAL"] = 2] = "FINAL";
    Round[Round["DONE"] = 3] = "DONE";
})(Round || (exports.Round = Round = {}));
var Status;
(function (Status) {
    Status[Status["UNPLAYED"] = 0] = "UNPLAYED";
    Status[Status["INPLAY"] = 1] = "INPLAY";
    Status[Status["PLAYED"] = 2] = "PLAYED";
})(Status || (exports.Status = Status = {}));
exports.NO_QUESTION = -1;
exports.NO_BUZZ_IN_TIME = -1;
exports.NO_DAILY_DOUBLE_WAGER = -1;
exports.NO_FINAL_JEOPARDY_WAGER = -1;
exports.NO_FINAL_JEOPARDY_SUBMISSION = "___no submission yet___";
var GUIUserType;
(function (GUIUserType) {
    GUIUserType[GUIUserType["UNDEFINED"] = 0] = "UNDEFINED";
    GUIUserType[GUIUserType["ADMIN"] = 1] = "ADMIN";
    GUIUserType[GUIUserType["PLAYER"] = 2] = "PLAYER";
    GUIUserType[GUIUserType["OBSERVER"] = 3] = "OBSERVER";
})(GUIUserType || (exports.GUIUserType = GUIUserType = {}));
//# sourceMappingURL=stateTypes.js.map